jQuery(function()
{    
    $("[data-comp=slick]").slick({
        fade: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        pauseOnFocus: false
    });
});


var Video = function(elem)
{
    // DOM.
    this.$elem  = jQuery(elem);
    this.$video = this.$elem.find('video');
    this.$mute  = this.$elem.find('[data-role=mute]');
 
    // Events.
    this.$mute.on('click', jQuery.proxy(this.onMuteBtnClick, this));
};


Video.prototype.onMuteBtnClick = function(event)
{
    this.$video[0].muted = !this.$video[0].muted;
    this.$elem.toggleClass('unmuted');
};


jQuery(function()
{
    // Creates one instance per component,
    // allows to have the same component multiple times on same page.
    // Preference: target a data attribute for distinction between style and functionality.
    jQuery('[data-comp="video"]').each(function() {
        var comp = new Video(this);
    });
});

const consoleStyle = "font-family:monospace;background-color:#3172a1;padding:2px 6px;color:white;border-radius:3px;";
console.log("%cWeb Development", consoleStyle, "https://sebastien.vignol.be");